<template>
  <div class="pro-item">
    <div v-if="proLoading" style="text-align:center;line-height:500px;">加载中...</div>
    <div v-if="proList &&!proLoading&& proList.length > 0" @click="goDetail(item)" class="pro-item-wrap" v-for="(item, index) in proList" :key="'pro-wrap-' + index">
      <p :title="item.name" v-if="item.name" class="wrap-title">{{item.name}}</p>
      <img v-if="item.banner[0]" :src="item.banner[0]" />
      <img src="@assets/img/empty.png" v-else>
      <div class="wrap-com">
        <p v-if="item.compName" :title="item.compName">{{item.compName}}</p>
        <!-- <i style="color:#b1262d;" class="icon iconfont icon-love"></i> -->
        <i style="color:#b1262d;" class="icon iconfont icon-love" @click.stop="cancelCollect(item)" v-if="item.isFollow"></i>
        <i style="color:#bfbfbf;" class="icon iconfont icon-guanzhu-xian" @click.stop="addCollect(item)" v-else></i>
      </div>
    </div>
    <div v-if="!proLoading && proList && proList.length == 0" style="line-height:500px;text-align:center;">
      暂无数据
    </div>
    <div class="m-page" v-if="totalCount > pageSize">
      <Page
        show-total
        show-elevator
        :page-size="pageSize"
        :current="pageIndex"
        :total="totalCount"
        show-sizer
        @on-change="changePage"
        @on-page-size-change="changePageSize"
      />  
    </div>
    
    <gLogin :show="show" @close="show=false;" />
  </div>
</template>

<script>
import gLogin from "@components/gLogin/gLogin.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "pro-item",
  props: {
    proList: {
      type: Array,
      default: []
    },
    pageIndex: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    totalCount: {
      type: Number,
      default: 0
    },
    proLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
    };
  },
  components: {
    gLogin
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibiton: "loginModule/getExhibition"
    }),
    opt() {
      return {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        totalCount: this.totalCount
      }
    }
  },
  methods: {
    init() {},
    changePage(e) {
      this.opt.pageIndex = e;
      this.$emit("getProList",this.opt);
    },
    changePageSize(e) {
      this.opt.pageSize = e;
      this.$emit("getProList",this.opt);
    },
    goDetail(item) {
      const url = location.origin + `/pro-details/${item.id}?compId=${item.compId}`;
      window.open(url, "_blank");
      // this.$router.push(`/pro-details/${item.id}?compId=${item.compId}`);
    },
    addCollect(item) {
      // console.log(item)
      if (!this.user) {
        this.$Message.warning("请登录后关注");
        this.show = true;
        return;
      }
      this.$http.get(`/api/ProductFollow/follow?userId=${this.user.userId}&productId=${item.id}`,this.$store.state.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                    this.$emit('addProsuccess',item)
                  }else{
                    this.$Message.error("关注失败，请重新尝试");
                  }
                })
    },
    cancelCollect(item){
      if (!this.user) {
        this.$Message.warning("请登录后操作");
        this.show = true;
        return;
      }
      this.$http.get(`/api/ProductFollow/unfollow?userId=${this.user.userId}&productId=${item.id}`,this.$store.state.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                    this.$emit('cancelProsuccess',item)
                  }else{
                    this.$Message.error("取消失败，请重新尝试");
                  }
                })

    }
  }
};
</script>

<style scoped lang='scss'>
.pro-item {
  background-color: #fff;
  padding: 20px 0 20px 20px;
  margin-bottom: 50px;
  &-wrap {
    width: 430px;
    height: 380px;
    border: solid 2px #f5f5f5;
    margin: 0 20px 20px 0;
    cursor: pointer;
    display: inline-block;
    font-size: 0;
    transition: 0.2s;
    &:hover {
      transform: scale(1.1);
    }
    .wrap-title {
      width: 100%;
      height: 48px;
      line-height: 48px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      padding: 0 15px;
      font-size: 16px;
      color: #024c8b;
    }
    img {
      width: 100%;
      height: calc(100% - 115px);
      padding: 0 15px;
      margin-bottom: 15px;
    }
    .wrap-com {
      width: 100%;
      height: 52px;
      display: flex;
      align-items: center;
      padding: 0 10px 0 15px;
      background-color: #f5f5f5;
      font-size: 14px;
      color: #333;
      p {
        width: 100%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      i {
        font-size: 24px;
      }
    }
  }
  .m-page {
    width: 100%;
    padding: 20px 0;
    text-align: center;
  }
}
</style>
<style lang="scss">
.ivu-message {
  z-index: 1050 !important;
}
</style>